import { useMemo } from "react"
import { Typography, TypographyProps } from "@mui/material"
import { KojinSenmoni } from "interface/kojin"
import { SearchsSenmoniResult } from "interface/search/senmoni"

type SenmoniTextProps = {
  senmoni: KojinSenmoni
  searchsSenmoni?: SearchsSenmoniResult[]
  suffix?: string
} & TypographyProps
export const SenmoniText = ({
  senmoni,
  searchsSenmoni,
  suffix,
  ...others
}: SenmoniTextProps) => {
  const {
    name,
    isPrimary
   } = useMemo(
    () => {
      let name = senmoni.senmoniName ?? ''
      const suffix = []
      if (senmoni.sidoui) suffix.push('指導医')
      if (senmoni.senmoni) suffix.push('専門医')
      if (senmoni.ninteii) suffix.push('認定医')
      if (suffix.length > 0) {
        name = (name.endsWith('専門医') ? name.substring(0, name.length - 3) : name) + suffix.join('/')
      }
      return {
        name,
        isPrimary: searchsSenmoni?.some(s => s.senmoniCode === senmoni.senmoniCode)
      }
    },
    [senmoni, searchsSenmoni]
  )
	return (
		<Typography
      component="span"
      variant="body2"
      color='text.primary'
      fontWeight={isPrimary ? 'bold' : undefined}
      {...others}
    >
      {name}
      {suffix}
    </Typography>
	)
}
